import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WorkspaceValidatorService } from '../core/workspace-validator.service';

export const workspaceGuard: CanActivateFn = () => {
  const validator = inject(WorkspaceValidatorService);
  if (validator.isValid) return true;
  return inject(Router).createUrlTree(['/workspace-not-found']);
};
